import React, { useMemo, useState, useEffect, useCallback } from "react";
import { useIntl } from "react-intl";

import ServiceWithNumber from "./serviceWithNumber";
import InfoLabel from "../../app/generic/infoLabel";

const peurServiceFieldName = "euroPallet",
  peurCountFieldName = "euroPalletCount";

const EuroPallet = ({
  countOfEuroPallets,
  initialServices,
  wrappings,
  disabled,
  mainForm,
  collis,
  rules,
}) => {
  const intl = useIntl();
  const { getFieldDecorator } = mainForm;

  const [countOfPEur, setCountOfPEur] = useState(countOfEuroPallets || 0);
  const pEurWrapping = useMemo(
    () => wrappings && wrappings.find((w) => w.name === "P-EUR"),
    [wrappings]
  );

  useEffect(() => {
    collis &&
      pEurWrapping &&
      setCountOfPEur(
        collis.filter((c) => c.wrappingId === pEurWrapping.id).length
      );
  }, [collis, pEurWrapping]);

  const handlePEurValidation = useCallback(
    (_rule, value, callback) => {
      callback(
        value < countOfPEur
          ? new Error(
              intl.formatMessage({
                id: "consignment.services.peurMinCount",
                defaultMessage:
                  "Počet P-EUR musí být větší nebo roven počtu kusů s obalem P-EUR!",
              })
            )
          : undefined
      );
    },
    [intl, countOfPEur]
  );

  return countOfPEur > 0 && rules.euroPalletBack ? (
    <ServiceWithNumber
      disabledService
      disabled={disabled}
      showNumber={countOfPEur > 0}
      min={
        initialServices &&
        initialServices.euroPalletCount &&
        countOfPEur > initialServices.euroPalletCount
          ? initialServices.euroPalletCount
          : countOfPEur
      }
      serviceLabel={
        <InfoLabel
          label={intl.formatMessage({
            id: "consignment.services.peur",
            defaultMessage: "P-EUR zpět",
          })}
          info={intl.formatMessage({
            id: "consignment.services.peur.info",
            defaultMessage:
              "Pokud si přejete palety nevracet zvolte prosím u odpovídajících kusů obal 'Paleta' namísto 'P-EUR'.",
          })}
        />
      }
      serviceFieldName={peurServiceFieldName}
      numberLabel={intl.formatMessage({
        id: "consignment.services.peurCount",
        defaultMessage: "Počet P-EUR",
      })}
      numberFieldName={peurCountFieldName}
      numberMessage={intl.formatMessage({
        id: "consignment.services.emptyPeurCount",
        defaultMessage: "Zadejte prosím počet P-EUR!",
      })}
      onValidation={handlePEurValidation}
      getFieldDecorator={getFieldDecorator}
      initialValue={
        (initialServices && initialServices.euroPalletCount) || countOfPEur
      }
    />
  ) : (
    <></>
  );
};

export default EuroPallet;
